import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/ArrowsIn.es.js";
const r = o.forwardRef((e, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...e, weights: n }));
r.displayName = "ArrowsInIcon";
const c = r;
export {
  c as ArrowsIn,
  r as ArrowsInIcon
};
